import React from 'react'
import PriceRowPointsSpend from '../PriceRowPointsSpend'
import Group from 'components/utils/Group'
import PriceRowPrice from '../PriceRowPrice'
import BodyText from 'LuxKit/Typography/BodyText'
import { rem } from 'polished'
import styled from 'styled-components'
import LoyaltyPointsEarnRatio from 'loyalty/components/Earn/LoyaltyPointsEarnRatio'
import PriceRowSale from '../PriceRowSale'
import PriceRowPointsSale from '../PriceRowPointsSale'

const OrText = styled(BodyText)`
  line-height: ${rem(20)};
`

interface Props {
  /**
   * The current price for the item
   * e.g. may be a sale price or regular price
   */
  price: number;
  /**
   * The original/regular price for the item
   *
   * If this is different than the current price
   * the stack will show the 'sale' variant
   */
  regularPrice: number;
  /**
   * Current price of the item in points
   * e.g. may be sale points or regular points
   */
  points?: number;
  /**
   * The original/regular price of the item in points
   */
  pointsRegularPrice: number;
  direction: 'horizontal' | 'stack';
  size: 'S' | 'L';
  earnRatio?: number;
}

function PriceRowMerchandisePriceStack(props: Props) {
  const {
    price,
    points,
    size,
    direction,
    earnRatio,
    regularPrice,
    pointsRegularPrice,
  } = props

  const isOnSale = price !== regularPrice
  const isOnPointsSale = points !== pointsRegularPrice

  return <Group
    direction={direction === 'horizontal' ? 'horizontal' : 'vertical'}
    gap={direction === 'horizontal' ? 8 : (size === 'S' ? 4 : 8)}
    tabletGap={8}
    verticalAlign={direction === 'horizontal' ? 'start' : undefined}
  >
    <div>
      {!!price && <PriceRowPrice price={price} size={size} saleUnit="" />}
      {isOnSale && <PriceRowSale value={regularPrice} colour="neutral-three" />}
      {!!earnRatio && <LoyaltyPointsEarnRatio ratio={earnRatio} />}
    </div>
    <Group direction="horizontal" gap={8} verticalAlign="start">
      {!!price && !!points && <OrText variant="small" colour="neutral-three">or</OrText>}
      <div>
        {!!points && <PriceRowPointsSpend points={points} size={size} />}
        {isOnPointsSale && <PriceRowPointsSale value={pointsRegularPrice} colour="neutral-three" />}
      </div>
    </Group>
  </Group>
}

export default PriceRowMerchandisePriceStack
